import script from "./DataManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DataManagement.vue?vue&type=script&setup=true&lang=js"

import "./DataManagement.vue?vue&type=style&index=0&id=b5a9874e&lang=scss"

const __exports__ = script;

export default __exports__